<template>
    <tr class="counts-tool-field-container">
        <td class="field-name">
            <strong>{{field.properties.Name}}</strong>
        </td>
        <td>
            {{field.properties.FieldType}}
        </td>
        <td class="describe-field">
            <FormInputGroupView
                v-bind:inputs="form.inputs.groupBy"
                v-bind:values="form.values"
                v-on:FormInputGroup:change="formChange"
            />
        </td>
        <td>
            <div v-if="form.values.groupBy == 'true'">
                <FormInputGroupView
                    v-bind:inputs="form.inputs.configGeneral"
                    v-bind:values="form.values"
                    v-on:FormInputGroup:change="formChange"
                />
                <div v-if="field.properties.FieldType == 'Text'">
                    <FormInputGroupView
                        v-bind:inputs="form.inputs.configText"
                        v-bind:values="form.values"
                        v-on:FormInputGroup:change="formChange"
                    />
                </div>
                <div v-if="field.properties.FieldType == 'Number'">
                    <FormInputGroupView
                        v-bind:inputs="form.inputs.configNumber"
                        v-bind:values="form.values"
                        v-on:FormInputGroup:change="formChange"
                    />
                </div>
                <div v-if="field.properties.FieldType == 'Decimal'">
                    <FormInputGroupView
                        v-bind:inputs="form.inputs.configDecimal"
                        v-bind:values="form.values"
                        v-on:FormInputGroup:change="formChange"
                    />
                </div>
                <div v-if="field.properties.FieldType == 'EmailAddress'">
                    <FormInputGroupView
                        v-bind:inputs="form.inputs.configEmail"
                        v-bind:values="form.values"
                        v-on:FormInputGroup:change="formChange"
                    />
                </div>
                <div v-if="field.properties.FieldType == 'Date'">
                    <FormInputGroupView
                        v-bind:inputs="form.inputs.configDate"
                        v-bind:values="form.values"
                        v-on:FormInputGroup:change="formChange"
                    />
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import FormInputGroupView, { FormInputGroup } from '@/components/form-input-group2/FormInputGroup';

var formGroups = () => {
    return {
        groupBy: [
            {
                "key": "groupBy",
                //"label": `Group by ${fieldName}`,
                "label": `Group by`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            }
        ],
        configGeneral: [
            {
                "key": "showTopN",
                "label": `Show top <em>N</em> most frequent values`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            },
            {
                "key": "topN",
                "label": `Top <em>N</em> count`,
                "attrs": {
                    "type": "text",
                    "pattern": '^[0-9]+$',
                    "required": true
                },
                "classesCss": "top-n-count"
            },
            {
                "key": "showDistinctValues",
                "label": `Count distinct values`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            },
            {
                "key": "showNulls",
                "label": `Count/Pct null values`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            }
        ],
        configText: [
            {
                "key": "showEmpty",
                "label": `Count/Pct empty string values`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            },
            {
                "key": "showMinMaxLen",
                "label": `Min/Max string length`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            }
        ],
        configEmail: [
            {
                "key": "groupByDomain",
                "label": `Group by domain`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            }
        ],
        configNumber: [
            {
                "key": "showMinMaxNumber",
                "label": `Show min/max number values`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            }
        ],
        configDecimal: [
            {
                "key": "showMinMaxDecimal",
                "label": `Show min/max number values`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            },
            {
                "key": "roundDecimal",
                "label": `Round to <em>N</em> decimal places`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            },
            {
                "key": "decimalPlacesDecimal",
                "label": `Decimal places`,
                "attrs": {
                    "type": "text",
                    "pattern": '^[0-9]+$',
                    "required": true
                },
                "classesCss": "decimal-places-decimal"
            }
        ],
        configDate: [
            {
                "key": "showMinMaxDate",
                "label": `Show min/max date values`,
                "attrs": {
                    "type": "checkbox",
                    "true-value": 'true',
                    "false-value": 'false'
                }
            },
            {
                "key": "groupByFormatDate",
                "label": "Group by",
                "attrs": {
                    "type": "select"
                },
                "options": [
                    {
                        "label": "none - raw date",
                        "value": ""
                    },
                    {
                        "label": "yyyy (4-digit year)",
                        "value": "yyyy"
                    },
                    {
                        "label": "yyyy-MM (4-digit year, month)",
                        "value": "yyyy-MM"
                    },
                    {
                        "label": "yyyy-MM-dd (4-digit year, month, day)",
                        "value": "yyyy-MM-dd"
                    },
                    {
                        "label": "yyyy-MM-dd H:00:00 (4-digit year, month, day, hour)",
                        "value": "yyyy-MM-dd H:00:00"
                    },
                    {
                        "label": "MM (month)",
                        "value": "MM"
                    },
                    {
                        "label": "H (hour)",
                        "value": "H"
                    },
                    {
                        "label": "Months ago from today - datediff(month, [field_name], getdate())",
                        "value": "datediff-month" // datediff(month, src.last_engagement_date, getdate())
                    },
                    {
                        "label": "Quarters ago from today - datediff(quarter, [field_name], getdate())",
                        "value": "datediff-quarter" // datediff(quarter, src.last_engagement_date, getdate())
                    }
                ]
            }
        ]
    };
};

export var DescribeDEField = {
    defaultValues: {
        groupBy: 'false',
        showTopN: 'true',
        topN: '10',
        showDistinctValues: 'true',
        showNulls: 'true',
        showEmpty: 'true',
        showMinMaxLen: 'true',
        groupByDomain: 'true',
        showMinMaxNumber: 'true',
        showMinMaxDecimal: 'true',
        roundDecimal: 'true',
        decimalPlacesDecimal: '2',
        showMinMaxDate: 'true',
        groupByFormatDate: 'yyyy-MM-dd'
    }
};

export default {
    name: 'DescribeDEFieldView',
    components: {
        FormInputGroupView
    },
    props: {
        "field": Object
    },
    data: function() {
        var inputs = formGroups(this.field.properties.Name);
        var data = {
            form: {
                inputs: FormInputGroup.makeInputs(inputs),
                values: FormInputGroup.makeValues(inputs, this.field.values)
            }
        };
        return data;
    },
    created: function() {
        this.formInputs = FormInputGroup.util(() => this.form.inputs);
    },
    methods: {
        formChange: function(event) {
            var input;

            this.form.values[event.key] = event.value;

            input = this.formInputs.get('topN');
            if (this.form.values.showTopN == 'true') {
                input.attrs.disabled = false;
            } else {
                input.attrs.disabled = true;
                this.form.values.topN = DescribeDEField.defaultValues.topN;
            }

            input = this.formInputs.get('decimalPlacesDecimal');
            if (this.form.values.roundDecimal == 'true') {
                input.attrs.disabled = false;
            } else {
                input.attrs.disabled = true;
                this.form.values.decimalPlacesDecimal = DescribeDEField.defaultValues.decimalPlacesDecimal;
            }
            this.$emit(
                'DescribeDEField:update',
                this.field.properties.Name,
                JSON.parse(JSON.stringify(this.form.values))
            );
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
